import React, { FunctionComponent } from 'react';

import { StyledCirclePlaceholder } from './circle-placeholder.styled';

export const CirclePlaceholder: FunctionComponent = (props) => <StyledCirclePlaceholder {...props} />;
